import React from 'react';

export function ScopeSelector({ currentScope, project, storyId, onChange }) {
  if (!project) return null;

  const options = [
    { type: 'project', id: project.id, label: `\u25C6 Project: ${project.name}` },
    ...(project.stories || []).map(story => ({
      type: 'story',
      id: story.id,
      label: `\u251C\u2500 ${story.name}`
    }))
  ];

  const currentValue = `${currentScope.type}:${currentScope.id}`;

  const handleChange = (e) => {
    const [type, id] = e.target.value.split(':');
    onChange({ type, id });
  };

  return (
    <div className="scope-selector">
      <label className="scope-selector__label">Scope:</label>
      <select
        className="scope-selector__select"
        value={currentValue}
        onChange={handleChange}
      >
        {options.map(opt => (
          <option key={`${opt.type}:${opt.id}`} value={`${opt.type}:${opt.id}`}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default ScopeSelector;
